import API from '../../services/api.svelte.js';
import { notificate } from '../../services/notification.js';
import { locale, format } from 'svelte-i18n';
import { get as getStore } from 'svelte/store';



// store Promise to avoid multiple simultaneous API calls
let summariesPromise;
let summaries = [];
let updated_at = null;

export function search(config = {}) {

    summariesPromise = API.search('summary', config)
        .catch(() => {
            return Promise.resolve([]);
        })
        .then(psummaries => {
            summaries = psummaries;
            updated_at = new Date();
            return summaries;
        })
    ;

    return summariesPromise;
}


export function find(id, config = {}) {
    let summary;
    let summaryPromise = API.find('summary', id, config)
        .catch(() => {
            return Promise.resolve([]);
        })
        .then(psummary => {
            summary = psummary;
            return summary;
        })
    ;
    return summaryPromise;
}

export function save(data, files = [], config = {}) {
    return API.save('summary', data, files, config)
        .then(async (response) => {
            if (!response.ok) {
                let errors = await response.json();
                // api validation errors
                if(response.status == 401){

                    notificate('limitReached')
                }
                else {
                    let toastConfig = {
                        data: data.name,
                        options : {
                            "timeOut": "0",
                            "extendedTimeOut": "0",
                            "showDuration": "0",
                            "hideDuration": "0",
                            "closeButton": true
                        }

                    }
                    if(config && config.massive_addition) toastConfig.error = errors;
                    notificate('save_error', "toast", toastConfig);
                }
                throw errors;
            }
            return response.json();
        })
        .then(apiData => {
            notificate('save_ok', "toast", {data: apiData.name});
            //returns saved element to update dataTables
            return apiData;
        })
    ;
}

export function del(summary, config = {}) {
    let readLocale = getStore(locale);
    locale.set(readLocale);
    return API.del('summary', summary.id, config)
        .then(async (response) => {
            if (!response.ok) {
                // api validation errors
                notificate('delete_error', "toast", {data: getStore(format)("summary")});
                let errors = await response.json();
                throw errors;
            }
            return response.json();
        })
        .then(data => {
            notificate('delete_ok', "toast", {data: getStore(format)("summary")});
            return summaries;
        })
    ;
}

export default {
    search,
    find,
    save,
    del,
}
